module.exports = __webpack_public_path__ + "img/most1.e3c072df.png";